export default __webpack_public_path__ + "static/media/cake25.325cf5c2.jpg";